export default {
    MATRIX_RESULTS_REQUEST:                     'MATRIX_RESULTS_REQUEST',
    MATRIX_RESULTS_SUCCES:                      'MATRIX_RESULTS_SUCCES',
    MATRIX_RESULTS_ERROR:                       'MATRIX_RESULTS_ERROR',

    MATRIX_RESULTS_PRINT_REQUEST:               'MATRIX_RESULTS_PRINT_REQUEST',
    MATRIX_RESULTS_PRINT_SUCCESS:               'MATRIX_RESULTS_PRINT_SUCCESS',
    MATRIX_RESULTS_PRINT_ERROR:                 'MATRIX_RESULTS_PRINT_ERROR'
}